import React from 'react'
import _ from 'lodash'
import {
  Accordion,
  Form,
  Input,
  Popup,
  Loader,
} from 'semantic-ui-react'

import _t from 'utils/i18n_helper'


const MydClassrooms = props => {
  const {
    styled,
    resetable=false,
    multiple=false,
    autoselect=true,
    treeNodes,
    selected,
    onChange,
    input,
    isLoading
  } = props

  const renderAccordion = items => {
    if (isLoading === true) {
      return {
        comp: <Loader inline active size='small'>Loading</Loader>
      }
    }

    let panels = [],
        renderItems = [],
        renderPanels = null,
        checkTop = [],
        hasChildChecked = false,
        indexFolder = 0

    const radio = ! multiple

    _.each(items, (i, index) => {
      const childItems = _.filter(treeNodes.data, { parentId: i.id }),
            selectedId = i.id

      if (i.isLeaf !== true) {
        let res = renderAccordion(childItems),
            comp = res.comp,
            accordionTitle

        hasChildChecked = hasChildChecked || res.hasChildChecked

        if (res.hasChildChecked) {
          checkTop.push(indexFolder)
        }

        indexFolder++

        if(i.parentId === 0) {
          accordionTitle = _t('ALL_CLASSGROUPS', true)
        } else {
          accordionTitle = i.name
        }

        if ( ! _.isEmpty(childItems)) {
          panels.push({
            title: accordionTitle,
            content: { content: comp, key: `form_field_group_${i.id}` },
            key: i.id,
          })
        } else {
        }

      } else {
        let checked = false

        if (multiple) {
          checked = _.includes(selected, selectedId)
        } else {
          checked = selected === selectedId
        }

        if (checked) {
          hasChildChecked = true
        }

        let name = (
          <Form.Field
            key={`form_field_${i.name}_${i.id}`}
          >
            <Form.Checkbox
              radio={ radio }
              label={ i.name }
              onChange={ onChange }
              value={ i.id }
              checked={ checked }
            />
          </Form.Field>
        )
        renderItems.push(name)
      }
    })

    if (!_.isEmpty(panels)) {
      renderPanels = (
        <Accordion
          defaultActiveIndex={ checkTop }
          exclusive={ false }
          styled={ _.isUndefined(styled) ? true : styled }
          panels={ panels }
        />
      )
    }

    return {
      hasChildChecked,
      comp: (
        <>
          {renderItems}
          {renderPanels}
        </>
      )
    }
  }

  React.useEffect(() => {
    const childs = _.filter(treeNodes.data, item => item.isLeaf === true )
    if (childs.length === 1 && autoselect) {
      onChange({}, {value: childs[0].id})
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  let selectedValues = (
    _.isArray(selected) ?
    _.chain(selected).map(s => _.chain(treeNodes.data).find({id: s}).get('name', null).value()).value().join(', ') :
    _.chain(treeNodes.data).find({id: selected}).get('name', null).value()
  )

  if (input) {
    return (
      <Popup
        trigger={
          <Input
            fluid
            //selection
            value={ selectedValues || '' }
            placeholder='Classgroups'
            readOnly
            id='inputTreeNodeSelector'
            loading={ isLoading === true }
            icon={
              resetable &&
              selectedValues &&
              {
                name: 'close',
                link: true,
                onClick: (e) => onChange({}, {value: null}),
              }
            }
          />
        }
        id='treeNodeSelector'
        flowing
        position='bottom left'
        on='click'
      >
        {
          renderAccordion(
            _.filter(props.treeNodes.data, { parentId: 0 }),
          ).comp
        }
      </Popup>
    )
  }

  return renderAccordion(
    _.filter(props.treeNodes.data, { parentId: 0 }),
  ).comp
}

export default MydClassrooms
